module.exports = __webpack_public_path__ + "static/media/007.d62c5519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/007.jpg
// module id = 514
// module chunks = 0